export default {
  SET_MEALS (state, meals) {
    state.meals = meals
  },
  REMOVE_RECORD (state, itemId) {
    const mealIndex = state.meals.findIndex((u) => u.id === itemId)
    state.meals.splice(mealIndex, 1)
  }
}
